import { parseColor } from '@antv/g';
export function parseToRGB(c) {
    if (typeof c === 'object')
        return c;
    return parseColor(c);
}
//# sourceMappingURL=color.js.map